import MicroModal from 'micromodal';
import { content } from '../../tailwind.config';

export default function eventListModal () {

    const bodyCssClass = 'modal-open';

    const Selector = {
        MODAL_OPEN: '[data-event-modal-trigger]',
        MODAL_CONTAINER: '.js-event-list-modal',
    }

    const element = {
        MODAL_OPEN: document.querySelectorAll(Selector.MODAL_OPEN),
        MODAL_CONTAINER: document.querySelectorAll(Selector.MODAL_CONTAINER),
    }

    function init () {
        if(element.MODAL_CONTAINER) {
            window.classicModal = {
                init: MicroModal.init({
                    onShow: modal => onShowActions(modal),
                    onClose: modal => onCloseActions(modal),
                    openTrigger: 'data-event-modal-trigger',
                }),
                show: MicroModal.show,
                close: MicroModal.close,
            };

            element.MODAL_OPEN.forEach(trigger => {
                const contentId = trigger.dataset.eventId;

                trigger.addEventListener('click', () => {
                    document.getElementById(contentId).classList.remove('hidden');
                })
            });
        }
    }

    function onCloseActions (modal) {
        modal.setAttribute("inert", true);
        document.body.classList.remove(bodyCssClass);
        modal.querySelectorAll('.modal-krash__article').forEach(modalArticle => {
            modalArticle.classList.add('hidden');
        });
    }

    function onShowActions (modal) {
        modal.removeAttribute("inert");
        modal.querySelector("[data-micromodal-close]").focus();
        document.body.classList.add(bodyCssClass);
    }

    init();
}